export const inboxIssueStatuses = {
  archived: "archived",
  done: "done",
  inProgress: "in_progress",
  open: "open"
}

const inboxIssueStatusDefinitions = [
  { value: inboxIssueStatuses.open, label: "Open", menuLabel: "Open" },
  { value: inboxIssueStatuses.inProgress, label: "Pending merge", menuLabel: "Pending merge" },
  { value: inboxIssueStatuses.done, label: "Complete", menuLabel: "Complete" },
  { value: inboxIssueStatuses.archived, label: "Archived", menuLabel: "Archive" }
]
const inboxIssueStatusDefinitionByValue = new Map(
  inboxIssueStatusDefinitions.map((definition) => [ definition.value, definition ])
)

export const inboxIssueStatusOptions = inboxIssueStatusDefinitions.map((definition) => ({
  label: definition.menuLabel,
  value: definition.value
}))

const closedInboxIssueStatuses = new Set([ inboxIssueStatuses.done, inboxIssueStatuses.archived ])
const inboxIssueStatusClassNames = {
  [inboxIssueStatuses.archived]: "is-archived",
  [inboxIssueStatuses.done]: "is-done",
  [inboxIssueStatuses.inProgress]: "is-in-progress"
}

export function inboxIssueStatusLabel(status) {
  return inboxIssueStatusDefinitionByValue.get(status)?.label || humanizeInboxIssueStatus(status)
}

export function inboxIssueStatusClassName(issue) {
  return inboxIssueStatusClassNames[issue?.status] || ""
}

export function inboxIssueSeverityClassName(issue) {
  const severity = String(issue?.severity || "low").trim().toLowerCase().replace(/\s+/g, "-") || "low"
  const statusClassName = issue?.status === inboxIssueStatuses.inProgress ? " is-in-progress" : ""

  return `severity-dot is-${severity}${statusClassName}`
}

export function isClosedInboxIssue(issue) {
  return isClosedInboxIssueStatus(issue?.status)
}

export function isOpenInboxIssue(issue) {
  return Boolean(issue) && !isClosedInboxIssue(issue)
}

export function isClosedInboxIssueStatus(status) {
  return closedInboxIssueStatuses.has(status)
}

export function inboxIssueStatusToastLabel(status) {
  return status === inboxIssueStatuses.done ? "complete" : inboxIssueStatusLabel(status).toLowerCase()
}

function humanizeInboxIssueStatus(status) {
  const words = String(status || "").trim().split(/[_\s-]+/).filter(Boolean)
  if (words.length === 0) return "Unknown"

  return words
    .map((word, index) => index === 0 ? capitalize(word) : word.toLowerCase())
    .join(" ")
}

function capitalize(value) {
  const word = value.toLowerCase()

  return `${word.charAt(0).toUpperCase()}${word.slice(1)}`
}
